var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_669_33530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0H1C0.4 0 0 0.4 0 1V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V1C16 0.4 15.6 0 15 0ZM14 14H2V2H14V14Z",
    fill: "#264382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.09961 10.2996L9.09961 12.2996L13.3996 7.99961L11.9996 6.59961L8.89961 9.69961L5.89961 7.69961L2.59961 10.9996L3.99961 12.3996L6.09961 10.2996Z",
    fill: "#264382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 6C7.55228 6 8 5.55228 8 5C8 4.44772 7.55228 4 7 4C6.44772 4 6 4.44772 6 5C6 5.55228 6.44772 6 7 6Z",
    fill: "#264382"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_669_33530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export default __webpack_public_path__ + "static/media/ic_image.a82c4312.svg";
export { SvgComponent as ReactComponent };